import { Upload } from '@mui/icons-material';

import { basicRoles } from '@/router/consts';

import type { SidebarMenu } from '../../types';
import { uploadMap } from '../../uploadMaps';

const taskMenus: SidebarMenu[] = [
  {
    title: uploadMap['task-list'].title,
    path: uploadMap['task-list'].path,
    icon: <Upload />,
    roles: basicRoles,
  },
];

export default taskMenus;
